import { GeneralInfoSectionRow } from '../../components/GeneralInfoSectionRow';
import { HighwayContainer, JKNameContainer, RailwayContainer, UndergroundContainer } from './containers';
import { GeoBlockContainer } from '../GeoBlockContainer';

export function GeoContainer() {
  return (
    <GeneralInfoSectionRow>
      <JKNameContainer />
      <HighwayContainer />
      <UndergroundContainer />
      <RailwayContainer />
      <GeoBlockContainer />
    </GeneralInfoSectionRow>
  );
}
